// extracted by css-extract-rspack-plugin
export default {"root":"jlR91y"};